import { SaiQuickTourFormCoachStep } from 'app/ui/sai-quick-tour/sai-quick-tour-form-coach.types';

/** Guided walkthrough inside Add Division while the main tour is on that step. */
export const SAI_QUICK_TOUR_DIVISION_FORM_COACH_STEPS: readonly SaiQuickTourFormCoachStep[] = [
    {
        id: 'div-intro',
        titleKey: 'Tour · Meet the Add Division form',
        bodyKey:
            'We prefilled a demo division name. Divisions are the top level of your hierarchy — departments nest under them.',
    },
    {
        id: 'div-name',
        titleKey: 'Tour · Division Name',
        bodyKey:
            'Pick a clear name for this branch of the org (for example Finance or Operations). Demo value: “Demo Finance”.',
        fieldTourId: 'div-field-name',
        sampleKey: 'Demo Finance',
    },
    {
        id: 'div-save',
        titleKey: 'Tour · Save your division',
        bodyKey:
            'Click Add to create the division — next you will add a department under it.',
        fieldTourId: 'div-field-submit',
    },
];
